module.exports = __webpack_public_path__ + "img/绑定车辆.b3b9a9b6.png";